export const stateWiseCities = [
	{
		state: 'Alabama',
		abbreviation: 'AL',
		cities: [
			{
				name: 'Mobile',
				slug: '/self-storage/alabama/mobile/',
				yearly_visitors: 1196,
			},
			{
				name: 'Tuscaloosa',
				slug: '/self-storage/alabama/tuscaloosa/',
				yearly_visitors: 986,
			},
			{
				name: 'Auburn',
				slug: '/self-storage/alabama/auburn/',
				yearly_visitors: 845,
			},
			{
				name: 'Birmingham',
				slug: '/self-storage/alabama/birmingham/',
				yearly_visitors: 707,
			},
			{
				name: 'Gulf Shores',
				slug: '/self-storage/alabama/gulf-shores/',
				yearly_visitors: 680,
			},
			{
				name: 'Prattville',
				slug: '/self-storage/alabama/prattville/',
				yearly_visitors: 444,
			},
			{
				name: 'Montgomery',
				slug: '/self-storage/alabama/montgomery/',
				yearly_visitors: 390,
			},
			{
				name: 'Dothan',
				slug: '/self-storage/alabama/dothan/',
				yearly_visitors: 348,
			},
			{
				name: 'Florence',
				slug: '/self-storage/alabama/florence/',
				yearly_visitors: 306,
			},
			{
				name: 'Foley',
				slug: '/self-storage/alabama/foley/',
				yearly_visitors: 303,
			},
		],
	},
	{
		state: 'Alaska',
		abbreviation: 'AK',
		cities: [
			{
				name: 'Anchorage',
				slug: '/self-storage/alaska/anchorage/',
				yearly_visitors: 1337,
			},
			{
				name: 'Wasilla',
				slug: '/self-storage/alaska/wasilla/',
				yearly_visitors: 71,
			},
			{
				name: 'Palmer',
				slug: '/self-storage/alaska/palmer/',
				yearly_visitors: 45,
			},
			{
				name: 'Fairbanks',
				slug: '/self-storage/alaska/fairbanks/',
				yearly_visitors: 42,
			},
			{
				name: 'Eagle River',
				slug: '/self-storage/alaska/eagle-river/',
				yearly_visitors: 32,
			},
			{
				name: 'Juneau',
				slug: '/self-storage/alaska/juneau/',
				yearly_visitors: 27,
			},
			{
				name: 'Soldotna',
				slug: '/self-storage/alaska/soldotna/',
				yearly_visitors: 13,
			},
			{
				name: 'North Pole',
				slug: '/self-storage/alaska/north-pole/',
				yearly_visitors: 7,
			},
			{
				name: 'Willow',
				slug: '/self-storage/alaska/willow/',
				yearly_visitors: 5,
			},
			{
				name: 'Kenai',
				slug: '/self-storage/alaska/kenai/',
				yearly_visitors: 4,
			},
		],
	},
	{
		state: 'Arizona',
		abbreviation: 'AZ',
		cities: [
			{
				name: 'Chandler',
				slug: '/self-storage/arizona/chandler/',
				yearly_visitors: 1469,
			},
			{
				name: 'Phoenix',
				slug: '/self-storage/arizona/phoenix/',
				yearly_visitors: 974,
			},
			{
				name: 'Yuma',
				slug: '/self-storage/arizona/yuma/',
				yearly_visitors: 873,
			},
			{
				name: 'Glendale',
				slug: '/self-storage/arizona/glendale/',
				yearly_visitors: 841,
			},
			{
				name: 'Flagstaff',
				slug: '/self-storage/arizona/flagstaff/',
				yearly_visitors: 710,
			},
			{
				name: 'Scottsdale',
				slug: '/self-storage/arizona/scottsdale/',
				yearly_visitors: 616,
			},
			{
				name: 'Tucson',
				slug: '/self-storage/arizona/tucson/',
				yearly_visitors: 570,
			},
			{
				name: 'Peoria',
				slug: '/self-storage/arizona/peoria/',
				yearly_visitors: 414,
			},
			{
				name: 'Gilbert',
				slug: '/self-storage/arizona/gilbert/',
				yearly_visitors: 353,
			},
			{
				name: 'Mesa',
				slug: '/self-storage/arizona/mesa/',
				yearly_visitors: 332,
			},
		],
	},
	{
		state: 'Arkansas',
		abbreviation: 'AR',
		cities: [
			{
				name: 'Fayetteville',
				slug: '/self-storage/arkansas/fayetteville/',
				yearly_visitors: 873,
			},
			{
				name: 'Little Rock',
				slug: '/self-storage/arkansas/little-rock/',
				yearly_visitors: 847,
			},
			{
				name: 'Jonesboro',
				slug: '/self-storage/arkansas/jonesboro/',
				yearly_visitors: 278,
			},
			{
				name: 'Springdale',
				slug: '/self-storage/arkansas/springdale/',
				yearly_visitors: 258,
			},
			{
				name: 'Rogers',
				slug: '/self-storage/arkansas/rogers/',
				yearly_visitors: 249,
			},
			{
				name: 'Bentonville',
				slug: '/self-storage/arkansas/bentonville/',
				yearly_visitors: 206,
			},
			{
				name: 'Hot Springs',
				slug: '/self-storage/arkansas/hot-springs/',
				yearly_visitors: 187,
			},
			{
				name: 'Fort Smith',
				slug: '/self-storage/arkansas/fort-smith/',
				yearly_visitors: 186,
			},
			{
				name: 'Conway',
				slug: '/self-storage/arkansas/conway/',
				yearly_visitors: 141,
			},
			{
				name: 'Mountain Home',
				slug: '/self-storage/arkansas/mountain-home/',
				yearly_visitors: 92,
			},
		],
	},
	{
		state: 'California',
		abbreviation: 'CA',
		cities: [
			{
				name: 'Los Angeles',
				slug: '/self-storage/california/los-angeles/',
				yearly_visitors: 4574,
			},
			{
				name: 'San Diego',
				slug: '/self-storage/california/san-diego/',
				yearly_visitors: 3495,
			},
			{
				name: 'San Francisco',
				slug: '/self-storage/california/san-francisco/',
				yearly_visitors: 2075,
			},
			{
				name: 'Daly City',
				slug: '/self-storage/california/daly-city/',
				yearly_visitors: 1365,
			},
			{
				name: 'Garden Grove',
				slug: '/self-storage/california/garden-grove/',
				yearly_visitors: 1168,
			},
			{
				name: 'San Jose',
				slug: '/self-storage/california/san-jose/',
				yearly_visitors: 1166,
			},
			{
				name: 'Fullerton',
				slug: '/self-storage/california/fullerton/',
				yearly_visitors: 1160,
			},
			{
				name: 'Pasadena',
				slug: '/self-storage/california/pasadena/',
				yearly_visitors: 1140,
			},
			{
				name: 'La Mesa',
				slug: '/self-storage/california/la-mesa/',
				yearly_visitors: 1129,
			},
			{
				name: 'Escondido',
				slug: '/self-storage/california/escondido/',
				yearly_visitors: 1093,
			},
		],
	},
	{
		state: 'Colorado',
		abbreviation: 'CO',
		cities: [
			{
				name: 'Westminster',
				slug: '/self-storage/colorado/westminster/',
				yearly_visitors: 1440,
			},
			{
				name: 'Denver',
				slug: '/self-storage/colorado/denver/',
				yearly_visitors: 1185,
			},
			{
				name: 'Grand Junction',
				slug: '/self-storage/colorado/grand-junction/',
				yearly_visitors: 1040,
			},
			{
				name: 'Colorado Springs',
				slug: '/self-storage/colorado/colorado-springs/',
				yearly_visitors: 785,
			},
			{
				name: 'Parker',
				slug: '/self-storage/colorado/parker/',
				yearly_visitors: 669,
			},
			{
				name: 'Fort Collins',
				slug: '/self-storage/colorado/fort-collins/',
				yearly_visitors: 665,
			},
			{
				name: 'Aurora',
				slug: '/self-storage/colorado/aurora/',
				yearly_visitors: 600,
			},
			{
				name: 'Centennial',
				slug: '/self-storage/colorado/centennial/',
				yearly_visitors: 564,
			},
			{
				name: 'Littleton',
				slug: '/self-storage/colorado/littleton/',
				yearly_visitors: 523,
			},
			{
				name: 'Arvada',
				slug: '/self-storage/colorado/arvada/',
				yearly_visitors: 499,
			},
		],
	},
	{
		state: 'Connecticut',
		abbreviation: 'CT',
		cities: [
			{
				name: 'Hartford',
				slug: '/self-storage/connecticut/hartford/',
				yearly_visitors: 1136,
			},
			{
				name: 'Stamford',
				slug: '/self-storage/connecticut/stamford/',
				yearly_visitors: 638,
			},
			{
				name: 'Norwalk',
				slug: '/self-storage/connecticut/norwalk/',
				yearly_visitors: 595,
			},
			{
				name: 'Waterbury',
				slug: '/self-storage/connecticut/waterbury/',
				yearly_visitors: 486,
			},
			{
				name: 'New Haven',
				slug: '/self-storage/connecticut/new-haven/',
				yearly_visitors: 438,
			},
			{
				name: 'Bridgeport',
				slug: '/self-storage/connecticut/bridgeport/',
				yearly_visitors: 411,
			},
			{
				name: 'Storrs Mansfield',
				slug: '/self-storage/connecticut/storrs-mansfield/',
				yearly_visitors: 228,
			},
			{
				name: 'Torrington',
				slug: '/self-storage/connecticut/torrington/',
				yearly_visitors: 175,
			},
			{
				name: 'Bristol',
				slug: '/self-storage/connecticut/bristol/',
				yearly_visitors: 139,
			},
			{
				name: 'Fairfield',
				slug: '/self-storage/connecticut/fairfield/',
				yearly_visitors: 137,
			},
		],
	},
	{
		state: 'Delaware',
		abbreviation: 'DE',
		cities: [
			{
				name: 'Wilmington',
				slug: '/self-storage/delaware/wilmington/',
				yearly_visitors: 731,
			},
			{
				name: 'Newark',
				slug: '/self-storage/delaware/newark/',
				yearly_visitors: 584,
			},
			{
				name: 'Dover',
				slug: '/self-storage/delaware/dover/',
				yearly_visitors: 107,
			},
			{
				name: 'Middletown',
				slug: '/self-storage/delaware/middletown/',
				yearly_visitors: 107,
			},
			{
				name: 'Bear',
				slug: '/self-storage/delaware/bear/',
				yearly_visitors: 88,
			},
			{
				name: 'Seaford',
				slug: '/self-storage/delaware/seaford/',
				yearly_visitors: 86,
			},
			{
				name: 'Hockessin',
				slug: '/self-storage/delaware/hockessin/',
				yearly_visitors: 65,
			},
			{
				name: 'Smyrna',
				slug: '/self-storage/delaware/smyrna/',
				yearly_visitors: 65,
			},
			{
				name: 'Millsboro',
				slug: '/self-storage/delaware/millsboro/',
				yearly_visitors: 62,
			},
			{
				name: 'Rehoboth Beach',
				slug: '/self-storage/delaware/rehoboth-beach/',
				yearly_visitors: 62,
			},
		],
	},
	{
		state: 'Florida',
		abbreviation: 'FL',
		cities: [
			{
				name: 'Orlando',
				slug: '/self-storage/florida/orlando/',
				yearly_visitors: 1794,
			},
			{
				name: 'Miramar',
				slug: '/self-storage/florida/miramar/',
				yearly_visitors: 1382,
			},
			{
				name: 'Clearwater',
				slug: '/self-storage/florida/clearwater/',
				yearly_visitors: 1283,
			},
			{
				name: 'Pompano Beach',
				slug: '/self-storage/florida/pompano-beach/',
				yearly_visitors: 1198,
			},
			{
				name: 'Miami',
				slug: '/self-storage/florida/miami/',
				yearly_visitors: 1180,
			},
			{
				name: 'Kissimmee',
				slug: '/self-storage/florida/kissimmee/',
				yearly_visitors: 1139,
			},
			{
				name: 'Bradenton',
				slug: '/self-storage/florida/bradenton/',
				yearly_visitors: 1030,
			},
			{
				name: 'Melbourne',
				slug: '/self-storage/florida/melbourne/',
				yearly_visitors: 921,
			},
			{
				name: 'Jacksonville',
				slug: '/self-storage/florida/jacksonville/',
				yearly_visitors: 901,
			},
			{
				name: 'Cape Coral',
				slug: '/self-storage/florida/cape-coral/',
				yearly_visitors: 881,
			},
		],
	},
	{
		state: 'Georgia',
		abbreviation: 'GA',
		cities: [
			{
				name: 'Hinesville',
				slug: '/self-storage/georgia/hinesville/',
				yearly_visitors: 688,
			},
			{
				name: 'Macon',
				slug: '/self-storage/georgia/macon/',
				yearly_visitors: 678,
			},
			{
				name: 'Athens',
				slug: '/self-storage/georgia/athens/',
				yearly_visitors: 652,
			},
			{
				name: 'Atlanta',
				slug: '/self-storage/georgia/atlanta/',
				yearly_visitors: 595,
			},
			{
				name: 'Marietta',
				slug: '/self-storage/georgia/marietta/',
				yearly_visitors: 576,
			},
			{
				name: 'Lawrenceville',
				slug: '/self-storage/georgia/lawrenceville/',
				yearly_visitors: 520,
			},
			{
				name: 'Warner Robins',
				slug: '/self-storage/georgia/warner-robins/',
				yearly_visitors: 516,
			},
			{
				name: 'Gainesville',
				slug: '/self-storage/georgia/gainesville/',
				yearly_visitors: 483,
			},
			{
				name: 'Calhoun',
				slug: '/self-storage/georgia/calhoun/',
				yearly_visitors: 477,
			},
			{
				name: 'Covington',
				slug: '/self-storage/georgia/covington/',
				yearly_visitors: 401,
			},
		],
	},
	{
		state: 'Hawaii',
		abbreviation: 'HI',
		cities: [
			{
				name: 'Honolulu',
				slug: '/self-storage/hawaii/honolulu/',
				yearly_visitors: 2322,
			},
			{
				name: 'Kapolei',
				slug: '/self-storage/hawaii/kapolei/',
				yearly_visitors: 688,
			},
			{
				name: 'Kailua Kona',
				slug: '/self-storage/hawaii/kailua-kona/',
				yearly_visitors: 213,
			},
			{
				name: 'Kaneohe',
				slug: '/self-storage/hawaii/kaneohe/',
				yearly_visitors: 174,
			},
			{
				name: 'Kailua',
				slug: '/self-storage/hawaii/kailua/',
				yearly_visitors: 173,
			},
			{
				name: 'Waipahu',
				slug: '/self-storage/hawaii/waipahu/',
				yearly_visitors: 131,
			},
			{
				name: 'Ewa Beach',
				slug: '/self-storage/hawaii/ewa-beach/',
				yearly_visitors: 116,
			},
			{
				name: 'Pearl City',
				slug: '/self-storage/hawaii/pearl-city/',
				yearly_visitors: 51,
			},
			{
				name: 'Mililani Town',
				slug: '/self-storage/hawaii/mililani-town/',
				yearly_visitors: 41,
			},
			{
				name: 'Aiea',
				slug: '/self-storage/hawaii/aiea/',
				yearly_visitors: 31,
			},
		],
	},
	{
		state: 'Idaho',
		abbreviation: 'ID',
		cities: [
			{
				name: 'Boise',
				slug: '/self-storage/idaho/boise/',
				yearly_visitors: 2201,
			},
			{
				name: 'Meridian',
				slug: '/self-storage/idaho/meridian/',
				yearly_visitors: 419,
			},
			{
				name: 'Nampa',
				slug: '/self-storage/idaho/nampa/',
				yearly_visitors: 300,
			},
			{
				name: 'Idaho Falls',
				slug: '/self-storage/idaho/idaho-falls/',
				yearly_visitors: 296,
			},
			{
				name: 'Pocatello',
				slug: '/self-storage/idaho/pocatello/',
				yearly_visitors: 245,
			},
			{
				name: 'Post Falls',
				slug: '/self-storage/idaho/post-falls/',
				yearly_visitors: 238,
			},
			{
				name: 'Caldwell',
				slug: '/self-storage/idaho/caldwell/',
				yearly_visitors: 138,
			},
			{
				name: 'Coeur Dalene',
				slug: '/self-storage/idaho/coeur-dalene/',
				yearly_visitors: 134,
			},
			{
				name: 'Kuna',
				slug: '/self-storage/idaho/kuna/',
				yearly_visitors: 88,
			},
			{
				name: 'Star',
				slug: '/self-storage/idaho/star/',
				yearly_visitors: 82,
			},
		],
	},
	{
		state: 'Illinois',
		abbreviation: 'IL',
		cities: [
			{
				name: 'Springfield',
				slug: '/self-storage/illinois/springfield/',
				yearly_visitors: 2870,
			},
			{
				name: 'Chicago',
				slug: '/self-storage/illinois/chicago/',
				yearly_visitors: 2594,
			},
			{
				name: 'Belleville',
				slug: '/self-storage/illinois/belleville/',
				yearly_visitors: 662,
			},
			{
				name: 'Naperville',
				slug: '/self-storage/illinois/naperville/',
				yearly_visitors: 592,
			},
			{
				name: 'Joliet',
				slug: '/self-storage/illinois/joliet/',
				yearly_visitors: 412,
			},
			{
				name: 'Peoria',
				slug: '/self-storage/illinois/peoria/',
				yearly_visitors: 345,
			},
			{
				name: 'Champaign',
				slug: '/self-storage/illinois/champaign/',
				yearly_visitors: 294,
			},
			{
				name: 'Highland Park',
				slug: '/self-storage/illinois/highland-park/',
				yearly_visitors: 242,
			},
			{
				name: 'Carbondale',
				slug: '/self-storage/illinois/carbondale/',
				yearly_visitors: 241,
			},
			{
				name: 'Oak Park',
				slug: '/self-storage/illinois/oak-park/',
				yearly_visitors: 178,
			},
		],
	},
	{
		state: 'Indiana',
		abbreviation: 'IN',
		cities: [
			{
				name: 'Indianapolis',
				slug: '/self-storage/indiana/indianapolis/',
				yearly_visitors: 1278,
			},
			{
				name: 'Greenwood',
				slug: '/self-storage/indiana/greenwood/',
				yearly_visitors: 472,
			},
			{
				name: 'Fort Wayne',
				slug: '/self-storage/indiana/fort-wayne/',
				yearly_visitors: 466,
			},
			{
				name: 'West Lafayette',
				slug: '/self-storage/indiana/west-lafayette/',
				yearly_visitors: 425,
			},
			{
				name: 'Lafayette',
				slug: '/self-storage/indiana/lafayette/',
				yearly_visitors: 377,
			},
			{
				name: 'South Bend',
				slug: '/self-storage/indiana/south-bend/',
				yearly_visitors: 322,
			},
			{
				name: 'Carmel',
				slug: '/self-storage/indiana/carmel/',
				yearly_visitors: 320,
			},
			{
				name: 'Evansville',
				slug: '/self-storage/indiana/evansville/',
				yearly_visitors: 297,
			},
			{
				name: 'Gary',
				slug: '/self-storage/indiana/gary/',
				yearly_visitors: 256,
			},
			{
				name: 'Noblesville',
				slug: '/self-storage/indiana/noblesville/',
				yearly_visitors: 242,
			},
		],
	},
	{
		state: 'Iowa',
		abbreviation: 'IA',
		cities: [
			{
				name: 'Des Moines',
				slug: '/self-storage/iowa/des-moines/',
				yearly_visitors: 847,
			},
			{
				name: 'Ames',
				slug: '/self-storage/iowa/ames/',
				yearly_visitors: 560,
			},
			{
				name: 'Iowa City',
				slug: '/self-storage/iowa/iowa-city/',
				yearly_visitors: 542,
			},
			{
				name: 'Davenport',
				slug: '/self-storage/iowa/davenport/',
				yearly_visitors: 389,
			},
			{
				name: 'Sioux City',
				slug: '/self-storage/iowa/sioux-city/',
				yearly_visitors: 343,
			},
			{
				name: 'Cedar Rapids',
				slug: '/self-storage/iowa/cedar-rapids/',
				yearly_visitors: 145,
			},
			{
				name: 'Council Bluffs',
				slug: '/self-storage/iowa/council-bluffs/',
				yearly_visitors: 138,
			},
			{
				name: 'Dubuque',
				slug: '/self-storage/iowa/dubuque/',
				yearly_visitors: 119,
			},
			{
				name: 'West Des Moines',
				slug: '/self-storage/iowa/west-des-moines/',
				yearly_visitors: 73,
			},
			{
				name: 'Ankeny',
				slug: '/self-storage/iowa/ankeny/',
				yearly_visitors: 70,
			},
		],
	},

	{
		state: 'Kansas',
		abbreviation: 'KS',
		cities: [
			{
				name: 'Wichita',
				slug: '/self-storage/kansas/wichita/',
				yearly_visitors: 1348,
			},
			{
				name: 'Manhattan',
				slug: '/self-storage/kansas/manhattan/',
				yearly_visitors: 1216,
			},
			{
				name: 'Topeka',
				slug: '/self-storage/kansas/topeka/',
				yearly_visitors: 1106,
			},
			{
				name: 'Olathe',
				slug: '/self-storage/kansas/olathe/',
				yearly_visitors: 499,
			},
			{
				name: 'Lawrence',
				slug: '/self-storage/kansas/lawrence/',
				yearly_visitors: 280,
			},
			{
				name: 'Overland Park',
				slug: '/self-storage/kansas/overland-park/',
				yearly_visitors: 214,
			},
			{
				name: 'Junction City',
				slug: '/self-storage/kansas/junction-city/',
				yearly_visitors: 140,
			},
			{
				name: 'Atchison',
				slug: '/self-storage/kansas/atchison/',
				yearly_visitors: 112,
			},
			{
				name: 'Kansas City',
				slug: '/self-storage/kansas/kansas-city/',
				yearly_visitors: 93,
			},
			{
				name: 'Hutchinson',
				slug: '/self-storage/kansas/hutchinson/',
				yearly_visitors: 86,
			},
		],
	},

	{
		state: 'Kentucky',
		abbreviation: 'KY',
		cities: [
			{
				name: 'Louisville',
				slug: '/self-storage/kentucky/louisville/',
				yearly_visitors: 962,
			},
			{
				name: 'Bowling Green',
				slug: '/self-storage/kentucky/bowling-green/',
				yearly_visitors: 802,
			},
			{
				name: 'Lexington',
				slug: '/self-storage/kentucky/lexington/',
				yearly_visitors: 578,
			},
			{
				name: 'Georgetown',
				slug: '/self-storage/kentucky/georgetown/',
				yearly_visitors: 422,
			},
			{
				name: 'Richmond',
				slug: '/self-storage/kentucky/richmond/',
				yearly_visitors: 405,
			},
			{
				name: 'Nicholasville',
				slug: '/self-storage/kentucky/nicholasville/',
				yearly_visitors: 371,
			},
			{
				name: 'Frankfort',
				slug: '/self-storage/kentucky/frankfort/',
				yearly_visitors: 309,
			},
			{
				name: 'Radcliff',
				slug: '/self-storage/kentucky/radcliff/',
				yearly_visitors: 236,
			},
			{
				name: 'Owensboro',
				slug: '/self-storage/kentucky/owensboro/',
				yearly_visitors: 214,
			},
			{
				name: 'Ashland',
				slug: '/self-storage/kentucky/ashland/',
				yearly_visitors: 195,
			},
		],
	},

	{
		state: 'Louisiana',
		abbreviation: 'LA',
		cities: [
			{
				name: 'Lafayette',
				slug: '/self-storage/louisiana/lafayette/',
				yearly_visitors: 919,
			},
			{
				name: 'Baton Rouge',
				slug: '/self-storage/louisiana/baton-rouge/',
				yearly_visitors: 797,
			},
			{
				name: 'New Orleans',
				slug: '/self-storage/louisiana/new-orleans/',
				yearly_visitors: 779,
			},
			{
				name: 'Shreveport',
				slug: '/self-storage/louisiana/shreveport/',
				yearly_visitors: 400,
			},
			{
				name: 'Slidell',
				slug: '/self-storage/louisiana/slidell/',
				yearly_visitors: 265,
			},
			{
				name: 'Metairie',
				slug: '/self-storage/louisiana/metairie/',
				yearly_visitors: 232,
			},
			{
				name: 'Ruston',
				slug: '/self-storage/louisiana/ruston/',
				yearly_visitors: 158,
			},
			{
				name: 'Bossier City',
				slug: '/self-storage/louisiana/bossier-city/',
				yearly_visitors: 150,
			},
			{
				name: 'Monroe',
				slug: '/self-storage/louisiana/monroe/',
				yearly_visitors: 149,
			},
			{
				name: 'Lake Charles',
				slug: '/self-storage/louisiana/lake-charles/',
				yearly_visitors: 129,
			},
		],
	},

	{
		state: 'Maine',
		abbreviation: 'ME',
		cities: [
			{
				name: 'Old Orchard Beach',
				slug: '/self-storage/maine/old-orchard-beach/',
				yearly_visitors: 85,
			},
			{
				name: 'Yarmouth',
				slug: '/self-storage/maine/yarmouth/',
				yearly_visitors: 66,
			},
			{
				name: 'Lewiston',
				slug: '/self-storage/maine/lewiston/',
				yearly_visitors: 53,
			},
			{
				name: 'Brunswick',
				slug: '/self-storage/maine/brunswick/',
				yearly_visitors: 49,
			},
			{
				name: 'South Portland',
				slug: '/self-storage/maine/south-portland/',
				yearly_visitors: 45,
			},
			{
				name: 'Wells',
				slug: '/self-storage/maine/wells/',
				yearly_visitors: 39,
			},
			{
				name: 'Scarborough',
				slug: '/self-storage/maine/scarborough/',
				yearly_visitors: 36,
			},
			{
				name: 'Augusta',
				slug: '/self-storage/maine/augusta/',
				yearly_visitors: 35,
			},
			{
				name: 'Bangor',
				slug: '/self-storage/maine/bangor/',
				yearly_visitors: 34,
			},
			{
				name: 'Auburn',
				slug: '/self-storage/maine/auburn/',
				yearly_visitors: 33,
			},
		],
	},

	{
		state: 'Maryland',
		abbreviation: 'MD',
		cities: [
			{
				name: 'Rockville',
				slug: '/self-storage/maryland/rockville/',
				yearly_visitors: 843,
			},
			{
				name: 'Baltimore',
				slug: '/self-storage/maryland/baltimore/',
				yearly_visitors: 837,
			},
			{
				name: 'Annapolis',
				slug: '/self-storage/maryland/annapolis/',
				yearly_visitors: 763,
			},
			{
				name: 'Westminster',
				slug: '/self-storage/maryland/westminster/',
				yearly_visitors: 670,
			},
			{
				name: 'Laurel',
				slug: '/self-storage/maryland/laurel/',
				yearly_visitors: 530,
			},
			{
				name: 'Bethesda',
				slug: '/self-storage/maryland/bethesda/',
				yearly_visitors: 467,
			},
			{
				name: 'Columbia',
				slug: '/self-storage/maryland/columbia/',
				yearly_visitors: 446,
			},
			{
				name: 'Hagerstown',
				slug: '/self-storage/maryland/hagerstown/',
				yearly_visitors: 439,
			},
			{
				name: 'Waldorf',
				slug: '/self-storage/maryland/waldorf/',
				yearly_visitors: 426,
			},
			{
				name: 'Towson',
				slug: '/self-storage/maryland/towson/',
				yearly_visitors: 405,
			},
		],
	},
	{
		state: 'Massachusetts',
		abbreviation: 'MA',
		cities: [
			{
				name: 'Boston',
				slug: '/self-storage/massachusetts/boston/',
				yearly_visitors: 2196,
			},
			{
				name: 'Worcester',
				slug: '/self-storage/massachusetts/worcester/',
				yearly_visitors: 1349,
			},
			{
				name: 'Lowell',
				slug: '/self-storage/massachusetts/lowell/',
				yearly_visitors: 874,
			},
			{
				name: 'Cambridge',
				slug: '/self-storage/massachusetts/cambridge/',
				yearly_visitors: 715,
			},
			{
				name: 'Quincy',
				slug: '/self-storage/massachusetts/quincy/',
				yearly_visitors: 523,
			},
			{
				name: 'Framingham',
				slug: '/self-storage/massachusetts/framingham/',
				yearly_visitors: 399,
			},
			{
				name: 'Amherst',
				slug: '/self-storage/massachusetts/amherst/',
				yearly_visitors: 360,
			},
			{
				name: 'Springfield',
				slug: '/self-storage/massachusetts/springfield/',
				yearly_visitors: 251,
			},
			{
				name: 'Fall River',
				slug: '/self-storage/massachusetts/fall-river/',
				yearly_visitors: 131,
			},
			{
				name: 'Waltham',
				slug: '/self-storage/massachusetts/waltham/',
				yearly_visitors: 110,
			},
		],
	},
	{
		state: 'Michigan',
		abbreviation: 'MI',
		cities: [
			{
				name: 'Warren',
				slug: '/self-storage/michigan/warren/',
				yearly_visitors: 2297,
			},
			{
				name: 'Detroit',
				slug: '/self-storage/michigan/detroit/',
				yearly_visitors: 1498,
			},
			{
				name: 'Ann Arbor',
				slug: '/self-storage/michigan/ann-arbor/',
				yearly_visitors: 1158,
			},
			{
				name: 'Grand Rapids',
				slug: '/self-storage/michigan/grand-rapids/',
				yearly_visitors: 1111,
			},
			{
				name: 'Lansing',
				slug: '/self-storage/michigan/lansing/',
				yearly_visitors: 1017,
			},
			{
				name: 'Kalamazoo',
				slug: '/self-storage/michigan/kalamazoo/',
				yearly_visitors: 858,
			},
			{
				name: 'Holland',
				slug: '/self-storage/michigan/holland/',
				yearly_visitors: 168,
			},
			{
				name: 'Muskegon',
				slug: '/self-storage/michigan/muskegon/',
				yearly_visitors: 164,
			},
			{
				name: 'Traverse City',
				slug: '/self-storage/michigan/traverse-city/',
				yearly_visitors: 164,
			},
			{
				name: 'Southfield',
				slug: '/self-storage/michigan/southfield/',
				yearly_visitors: 163,
			},
		],
	},
	{
		state: 'Minnesota',
		abbreviation: 'MN',
		cities: [
			{
				name: 'Rochester',
				slug: '/self-storage/minnesota/rochester/',
				yearly_visitors: 332,
			},
			{
				name: 'Minneapolis',
				slug: '/self-storage/minnesota/minneapolis/',
				yearly_visitors: 284,
			},
			{
				name: 'St Paul',
				slug: '/self-storage/minnesota/st-paul/',
				yearly_visitors: 247,
			},
			{
				name: 'Duluth',
				slug: '/self-storage/minnesota/duluth/',
				yearly_visitors: 214,
			},
			{
				name: 'Mankato',
				slug: '/self-storage/minnesota/mankato/',
				yearly_visitors: 178,
			},
			{
				name: 'Blaine',
				slug: '/self-storage/minnesota/blaine/',
				yearly_visitors: 147,
			},
			{
				name: 'Woodbury',
				slug: '/self-storage/minnesota/woodbury/',
				yearly_visitors: 118,
			},
			{
				name: 'Alexandria',
				slug: '/self-storage/minnesota/alexandria/',
				yearly_visitors: 114,
			},
			{
				name: 'Anoka',
				slug: '/self-storage/minnesota/anoka/',
				yearly_visitors: 91,
			},
			{
				name: 'Stillwater',
				slug: '/self-storage/minnesota/stillwater/',
				yearly_visitors: 78,
			},
		],
	},
	{
		state: 'Mississippi',
		abbreviation: 'MS',
		cities: [
			{
				name: 'Gulfport',
				slug: '/self-storage/mississippi/gulfport/',
				yearly_visitors: 504,
			},
			{
				name: 'Jackson',
				slug: '/self-storage/mississippi/jackson/',
				yearly_visitors: 412,
			},
			{
				name: 'Brandon',
				slug: '/self-storage/mississippi/brandon/',
				yearly_visitors: 408,
			},
			{
				name: 'Southaven',
				slug: '/self-storage/mississippi/southaven/',
				yearly_visitors: 384,
			},
			{
				name: 'Starkville',
				slug: '/self-storage/mississippi/starkville/',
				yearly_visitors: 294,
			},
			{
				name: 'Tupelo',
				slug: '/self-storage/mississippi/tupelo/',
				yearly_visitors: 288,
			},
			{
				name: 'Hattiesburg',
				slug: '/self-storage/mississippi/hattiesburg/',
				yearly_visitors: 199,
			},
			{
				name: 'Columbus',
				slug: '/self-storage/mississippi/columbus/',
				yearly_visitors: 146,
			},
			{
				name: 'Meridian',
				slug: '/self-storage/mississippi/meridian/',
				yearly_visitors: 142,
			},
			{
				name: 'Olive Branch',
				slug: '/self-storage/mississippi/olive-branch/',
				yearly_visitors: 113,
			},
		],
	},
	{
		state: 'Missouri',
		abbreviation: 'MO',
		cities: [
			{
				name: 'St Louis',
				slug: '/self-storage/missouri/st-louis/',
				yearly_visitors: 1392,
			},
			{
				name: 'Springfield',
				slug: '/self-storage/missouri/springfield/',
				yearly_visitors: 829,
			},
			{
				name: 'Kansas City',
				slug: '/self-storage/missouri/kansas-city/',
				yearly_visitors: 783,
			},
			{
				name: 'Columbia',
				slug: '/self-storage/missouri/columbia/',
				yearly_visitors: 641,
			},
			{
				name: 'St Charles',
				slug: '/self-storage/missouri/st-charles/',
				yearly_visitors: 440,
			},
			{
				name: 'Independence',
				slug: '/self-storage/missouri/independence/',
				yearly_visitors: 362,
			},
			{
				name: 'Ozark',
				slug: '/self-storage/missouri/ozark/',
				yearly_visitors: 303,
			},
			{
				name: 'Wentzville',
				slug: '/self-storage/missouri/wentzville/',
				yearly_visitors: 290,
			},
			{
				name: 'Branson',
				slug: '/self-storage/missouri/branson/',
				yearly_visitors: 269,
			},
			{
				name: 'Troy',
				slug: '/self-storage/missouri/troy/',
				yearly_visitors: 204,
			},
		],
	},
	{
		state: 'Montana',
		abbreviation: 'MT',
		cities: [
			{
				name: 'Billings',
				slug: '/self-storage/montana/billings/',
				yearly_visitors: 711,
			},
			{
				name: 'Bozeman',
				slug: '/self-storage/montana/bozeman/',
				yearly_visitors: 493,
			},
			{
				name: 'Helena',
				slug: '/self-storage/montana/helena/',
				yearly_visitors: 176,
			},
			{
				name: 'Great Falls',
				slug: '/self-storage/montana/great-falls/',
				yearly_visitors: 122,
			},
			{
				name: 'Livingston',
				slug: '/self-storage/montana/livingston/',
				yearly_visitors: 46,
			},
			{
				name: 'Laurel',
				slug: '/self-storage/montana/laurel/',
				yearly_visitors: 13,
			},
			{
				name: 'Black Eagle',
				slug: '/self-storage/montana/black-eagle/',
				yearly_visitors: 10,
			},
			{
				name: 'Missoula',
				slug: '/self-storage/montana/missoula/',
				yearly_visitors: '-',
			},
			{
				name: 'Kalispell',
				slug: '/self-storage/montana/kalispell/',
				yearly_visitors: '-',
			},
			{
				name: 'Butte',
				slug: '/self-storage/montana/butte/',
				yearly_visitors: '-',
			},
		],
	},
	{
		state: 'Nebraska',
		abbreviation: 'NE',
		cities: [
			{
				name: 'Omaha',
				slug: '/self-storage/nebraska/omaha/',
				yearly_visitors: 1309,
			},
			{
				name: 'Lincoln',
				slug: '/self-storage/nebraska/lincoln/',
				yearly_visitors: 116,
			},
			{
				name: 'Bellevue',
				slug: '/self-storage/nebraska/bellevue/',
				yearly_visitors: 63,
			},
			{
				name: 'Papillion',
				slug: '/self-storage/nebraska/papillion/',
				yearly_visitors: 42,
			},
			{
				name: 'Plattsmouth',
				slug: '/self-storage/nebraska/plattsmouth/',
				yearly_visitors: 33,
			},
			{
				name: 'Elkhorn',
				slug: '/self-storage/nebraska/elkhorn/',
				yearly_visitors: 30,
			},
			{
				name: 'Gretna',
				slug: '/self-storage/nebraska/gretna/',
				yearly_visitors: 22,
			},
			{
				name: 'South Sioux City',
				slug: '/self-storage/nebraska/south-sioux-city/',
				yearly_visitors: 20,
			},
			{
				name: 'Fremont',
				slug: '/self-storage/nebraska/fremont/',
				yearly_visitors: 13,
			},
			{
				name: 'Seward',
				slug: '/self-storage/nebraska/seward/',
				yearly_visitors: 13,
			},
		],
	},
	{
		state: 'Nevada',
		abbreviation: 'NV',
		cities: [
			{
				name: 'Las Vegas',
				slug: '/self-storage/nevada/las-vegas/',
				yearly_visitors: 2348,
			},
			{
				name: 'Reno',
				slug: '/self-storage/nevada/reno/',
				yearly_visitors: 1302,
			},
			{
				name: 'Henderson',
				slug: '/self-storage/nevada/henderson/',
				yearly_visitors: 1027,
			},
			{
				name: 'North Las Vegas',
				slug: '/self-storage/nevada/north-las-vegas/',
				yearly_visitors: 604,
			},
			{
				name: 'Sparks',
				slug: '/self-storage/nevada/sparks/',
				yearly_visitors: 283,
			},
			{
				name: 'Carson City',
				slug: '/self-storage/nevada/carson-city/',
				yearly_visitors: 164,
			},
			{
				name: 'Fernley',
				slug: '/self-storage/nevada/fernley/',
				yearly_visitors: 163,
			},
			{
				name: 'Gardnerville',
				slug: '/self-storage/nevada/gardnerville/',
				yearly_visitors: 67,
			},
			{
				name: 'Boulder City',
				slug: '/self-storage/nevada/boulder-city/',
				yearly_visitors: 55,
			},
			{
				name: 'Mesquite',
				slug: '/self-storage/nevada/mesquite/',
				yearly_visitors: 49,
			},
		],
	},
	{
		state: 'New Hampshire',
		abbreviation: 'NH',
		cities: [
			{
				name: 'Manchester',
				slug: '/self-storage/new-hampshire/manchester/',
				yearly_visitors: 1030,
			},
			{
				name: 'Nashua',
				slug: '/self-storage/new-hampshire/nashua/',
				yearly_visitors: 152,
			},
			{
				name: 'Salem',
				slug: '/self-storage/new-hampshire/salem/',
				yearly_visitors: 141,
			},
			{
				name: 'Keene',
				slug: '/self-storage/new-hampshire/keene/',
				yearly_visitors: 135,
			},
			{
				name: 'Laconia',
				slug: '/self-storage/new-hampshire/laconia/',
				yearly_visitors: 113,
			},
			{
				name: 'Concord',
				slug: '/self-storage/new-hampshire/concord/',
				yearly_visitors: 110,
			},
			{
				name: 'Portsmouth',
				slug: '/self-storage/new-hampshire/portsmouth/',
				yearly_visitors: 89,
			},
			{
				name: 'Durham',
				slug: '/self-storage/new-hampshire/durham/',
				yearly_visitors: 75,
			},
			{
				name: 'Goffstown',
				slug: '/self-storage/new-hampshire/goffstown/',
				yearly_visitors: 72,
			},
			{
				name: 'Claremont',
				slug: '/self-storage/new-hampshire/claremont/',
				yearly_visitors: 71,
			},
		],
	},
	{
		state: 'New Jersey',
		abbreviation: 'NJ',
		cities: [
			{
				name: 'Jersey City',
				slug: '/self-storage/new-jersey/jersey-city/',
				yearly_visitors: 2157,
			},
			{
				name: 'Elizabeth',
				slug: '/self-storage/new-jersey/elizabeth/',
				yearly_visitors: 868,
			},
			{
				name: 'Paterson',
				slug: '/self-storage/new-jersey/paterson/',
				yearly_visitors: 606,
			},
			{
				name: 'Trenton',
				slug: '/self-storage/new-jersey/trenton/',
				yearly_visitors: 515,
			},
			{
				name: 'Princeton',
				slug: '/self-storage/new-jersey/princeton/',
				yearly_visitors: 270,
			},
			{
				name: 'Morristown',
				slug: '/self-storage/new-jersey/morristown/',
				yearly_visitors: 236,
			},
			{
				name: 'Montclair',
				slug: '/self-storage/new-jersey/montclair/',
				yearly_visitors: 220,
			},
			{
				name: 'Edison',
				slug: '/self-storage/new-jersey/edison/',
				yearly_visitors: 186,
			},
			{
				name: 'Newark',
				slug: '/self-storage/new-jersey/newark/',
				yearly_visitors: 179,
			},
			{
				name: 'East Orange',
				slug: '/self-storage/new-jersey/east-orange/',
				yearly_visitors: 167,
			},
		],
	},
	{
		state: 'New Mexico',
		abbreviation: 'NM',
		cities: [
			{
				name: 'Albuquerque',
				slug: '/self-storage/new-mexico/albuquerque/',
				yearly_visitors: 979,
			},
			{
				name: 'Carlsbad',
				slug: '/self-storage/new-mexico/carlsbad/',
				yearly_visitors: 332,
			},
			{
				name: 'Santa Fe',
				slug: '/self-storage/new-mexico/santa-fe/',
				yearly_visitors: 238,
			},
			{
				name: 'Las Cruces',
				slug: '/self-storage/new-mexico/las-cruces/',
				yearly_visitors: 218,
			},
			{
				name: 'Rio Rancho',
				slug: '/self-storage/new-mexico/rio-rancho/',
				yearly_visitors: 155,
			},
			{
				name: 'Alamogordo',
				slug: '/self-storage/new-mexico/alamogordo/',
				yearly_visitors: 133,
			},
			{
				name: 'Espanola',
				slug: '/self-storage/new-mexico/espanola/',
				yearly_visitors: 112,
			},
			{
				name: 'Los Lunas',
				slug: '/self-storage/new-mexico/los-lunas/',
				yearly_visitors: 105,
			},
			{
				name: 'Los Alamos',
				slug: '/self-storage/new-mexico/los-alamos/',
				yearly_visitors: 57,
			},
			{
				name: 'Hobbs',
				slug: '/self-storage/new-mexico/hobbs/',
				yearly_visitors: 53,
			},
		],
	},
	{
		state: 'New York',
		abbreviation: 'NY',
		cities: [
			{
				name: 'New York',
				slug: '/self-storage/new-york/new-york/',
				yearly_visitors: 5016,
			},
			{
				name: 'Westchester',
				slug: '/self-storage/new-york/westchester/',
				yearly_visitors: 2349,
			},
			{
				name: 'Buffalo',
				slug: '/self-storage/new-york/buffalo/',
				yearly_visitors: 2128,
			},
			{
				name: 'Syracuse',
				slug: '/self-storage/new-york/syracuse/',
				yearly_visitors: 1265,
			},
			{
				name: 'White Plains',
				slug: '/self-storage/new-york/white-plains/',
				yearly_visitors: 1125,
			},
			{
				name: 'Brooklyn',
				slug: '/self-storage/new-york/brooklyn/',
				yearly_visitors: 1028,
			},
			{
				name: 'Rochester',
				slug: '/self-storage/new-york/rochester/',
				yearly_visitors: 999,
			},
			{
				name: 'Binghamton',
				slug: '/self-storage/new-york/binghamton/',
				yearly_visitors: 910,
			},
			{
				name: 'Watertown',
				slug: '/self-storage/new-york/watertown/',
				yearly_visitors: 746,
			},
			{
				name: 'Poughkeepsie',
				slug: '/self-storage/new-york/poughkeepsie/',
				yearly_visitors: 711,
			},
		],
	},
	{
		state: 'North Carolina',
		abbreviation: 'NC',
		cities: [
			{
				name: 'Greensboro',
				slug: '/self-storage/north-carolina/greensboro/',
				yearly_visitors: 1632,
			},
			{
				name: 'Greenville',
				slug: '/self-storage/north-carolina/greenville/',
				yearly_visitors: 1332,
			},
			{
				name: 'Cary',
				slug: '/self-storage/north-carolina/cary/',
				yearly_visitors: 914,
			},
			{
				name: 'Raleigh',
				slug: '/self-storage/north-carolina/raleigh/',
				yearly_visitors: 906,
			},
			{
				name: 'Concord',
				slug: '/self-storage/north-carolina/concord/',
				yearly_visitors: 826,
			},
			{
				name: 'Jacksonville',
				slug: '/self-storage/north-carolina/jacksonville/',
				yearly_visitors: 708,
			},
			{
				name: 'Charlotte',
				slug: '/self-storage/north-carolina/charlotte/',
				yearly_visitors: 571,
			},
			{
				name: 'Kernersville',
				slug: '/self-storage/north-carolina/kernersville/',
				yearly_visitors: 570,
			},
			{
				name: 'Asheville',
				slug: '/self-storage/north-carolina/asheville/',
				yearly_visitors: 526,
			},
			{
				name: 'Durham',
				slug: '/self-storage/north-carolina/durham/',
				yearly_visitors: 507,
			},
		],
	},
	{
		state: 'North Dakota',
		abbreviation: 'ND',
		cities: [
			{
				name: 'Fargo',
				slug: '/self-storage/north-dakota/fargo/',
				yearly_visitors: 630,
			},
			{
				name: 'Grand Forks',
				slug: '/self-storage/north-dakota/grand-forks/',
				yearly_visitors: 441,
			},
			{
				name: 'Dickinson',
				slug: '/self-storage/north-dakota/dickinson/',
				yearly_visitors: 53,
			},
			{
				name: 'Williston',
				slug: '/self-storage/north-dakota/williston/',
				yearly_visitors: 48,
			},
			{
				name: 'West Fargo',
				slug: '/self-storage/north-dakota/west-fargo/',
				yearly_visitors: 42,
			},
			{
				name: 'Watford City',
				slug: '/self-storage/north-dakota/watford-city/',
				yearly_visitors: 23,
			},
			{
				name: 'Minot',
				slug: '/self-storage/north-dakota/minot/',
				yearly_visitors: 0,
			},
			{
				name: 'Valley City',
				slug: '/self-storage/north-dakota/valley-city/',
				yearly_visitors: '-',
			},
			{
				name: 'Devils Lake',
				slug: '/self-storage/north-dakota/devils-lake/',
				yearly_visitors: '-',
			},
			{
				name: 'Wahpeton',
				slug: '/self-storage/north-dakota/wahpeton/',
				yearly_visitors: '-',
			},
		],
	},
	{
		state: 'Ohio',
		abbreviation: 'OH',
		cities: [
			{
				name: 'Toledo',
				slug: '/self-storage/ohio/toledo/',
				yearly_visitors: 755,
			},
			{
				name: 'Dayton',
				slug: '/self-storage/ohio/dayton/',
				yearly_visitors: 670,
			},
			{
				name: 'Cincinnati',
				slug: '/self-storage/ohio/cincinnati/',
				yearly_visitors: 637,
			},
			{
				name: 'Columbus',
				slug: '/self-storage/ohio/columbus/',
				yearly_visitors: 562,
			},
			{
				name: 'Akron',
				slug: '/self-storage/ohio/akron/',
				yearly_visitors: 552,
			},
			{
				name: 'Middletown',
				slug: '/self-storage/ohio/middletown/',
				yearly_visitors: 420,
			},
			{
				name: 'Cleveland',
				slug: '/self-storage/ohio/cleveland/',
				yearly_visitors: 280,
			},
			{
				name: 'Canton',
				slug: '/self-storage/ohio/canton/',
				yearly_visitors: 225,
			},
			{
				name: 'Newark',
				slug: '/self-storage/ohio/newark/',
				yearly_visitors: 166,
			},
			{
				name: 'Lancaster',
				slug: '/self-storage/ohio/lancaster/',
				yearly_visitors: 139,
			},
		],
	},
	{
		state: 'Oklahoma',
		abbreviation: 'OK',
		cities: [
			{
				name: 'Tulsa',
				slug: '/self-storage/oklahoma/tulsa/',
				yearly_visitors: 1579,
			},
			{
				name: 'Broken Arrow',
				slug: '/self-storage/oklahoma/broken-arrow/',
				yearly_visitors: 608,
			},
			{
				name: 'Edmond',
				slug: '/self-storage/oklahoma/edmond/',
				yearly_visitors: 598,
			},
			{
				name: 'Norman',
				slug: '/self-storage/oklahoma/norman/',
				yearly_visitors: 423,
			},
			{
				name: 'Shawnee',
				slug: '/self-storage/oklahoma/shawnee/',
				yearly_visitors: 361,
			},
			{
				name: 'Stillwater',
				slug: '/self-storage/oklahoma/stillwater/',
				yearly_visitors: 312,
			},
			{
				name: 'Enid',
				slug: '/self-storage/oklahoma/enid/',
				yearly_visitors: 304,
			},
			{
				name: 'Oklahoma City',
				slug: '/self-storage/oklahoma/oklahoma-city/',
				yearly_visitors: 297,
			},
			{
				name: 'Moore',
				slug: '/self-storage/oklahoma/moore/',
				yearly_visitors: 279,
			},
			{
				name: 'Yukon',
				slug: '/self-storage/oklahoma/yukon/',
				yearly_visitors: 238,
			},
		],
	},
	{
		state: 'Oregon',
		abbreviation: 'OR',
		cities: [
			{
				name: 'Beaverton',
				slug: '/self-storage/oregon/beaverton/',
				yearly_visitors: 703,
			},
			{
				name: 'Bend',
				slug: '/self-storage/oregon/bend/',
				yearly_visitors: 413,
			},
			{
				name: 'Portland',
				slug: '/self-storage/oregon/portland/',
				yearly_visitors: 403,
			},
			{
				name: 'Gresham',
				slug: '/self-storage/oregon/gresham/',
				yearly_visitors: 388,
			},
			{
				name: 'Springfield',
				slug: '/self-storage/oregon/springfield/',
				yearly_visitors: 380,
			},
			{
				name: 'Salem',
				slug: '/self-storage/oregon/salem/',
				yearly_visitors: 318,
			},
			{
				name: 'Hillsboro',
				slug: '/self-storage/oregon/hillsboro/',
				yearly_visitors: 226,
			},
			{
				name: 'Corvallis',
				slug: '/self-storage/oregon/corvallis/',
				yearly_visitors: 216,
			},
			{
				name: 'Eugene',
				slug: '/self-storage/oregon/eugene/',
				yearly_visitors: 195,
			},
			{
				name: 'Tigard',
				slug: '/self-storage/oregon/tigard/',
				yearly_visitors: 189,
			},
		],
	},
	{
		state: 'Pennsylvania',
		abbreviation: 'PA',
		cities: [
			{
				name: 'Philadelphia',
				slug: '/self-storage/pennsylvania/philadelphia/',
				yearly_visitors: 1387,
			},
			{
				name: 'York',
				slug: '/self-storage/pennsylvania/york/',
				yearly_visitors: 1103,
			},
			{
				name: 'Lancaster',
				slug: '/self-storage/pennsylvania/lancaster/',
				yearly_visitors: 591,
			},
			{
				name: 'Allentown',
				slug: '/self-storage/pennsylvania/allentown/',
				yearly_visitors: 380,
			},
			{
				name: 'Lebanon',
				slug: '/self-storage/pennsylvania/lebanon/',
				yearly_visitors: 355,
			},
			{
				name: 'Pittsburgh',
				slug: '/self-storage/pennsylvania/pittsburgh/',
				yearly_visitors: 354,
			},
			{
				name: 'Bethlehem',
				slug: '/self-storage/pennsylvania/bethlehem/',
				yearly_visitors: 350,
			},
			{
				name: 'Erie',
				slug: '/self-storage/pennsylvania/erie/',
				yearly_visitors: 281,
			},
			{
				name: 'Harrisburg',
				slug: '/self-storage/pennsylvania/harrisburg/',
				yearly_visitors: 272,
			},
			{
				name: 'Reading',
				slug: '/self-storage/pennsylvania/reading/',
				yearly_visitors: 231,
			},
		],
	},
	{
		state: 'Rhode Island',
		abbreviation: 'RI',
		cities: [
			{
				name: 'Providence',
				slug: '/self-storage/rhode-island/providence/',
				yearly_visitors: 1420,
			},
			{
				name: 'Westerly',
				slug: '/self-storage/rhode-island/westerly/',
				yearly_visitors: 171,
			},
			{
				name: 'East Providence',
				slug: '/self-storage/rhode-island/east-providence/',
				yearly_visitors: 137,
			},
			{
				name: 'Warwick',
				slug: '/self-storage/rhode-island/warwick/',
				yearly_visitors: 133,
			},
			{
				name: 'North Kingstown',
				slug: '/self-storage/rhode-island/north-kingstown/',
				yearly_visitors: 95,
			},
			{
				name: 'Cranston',
				slug: '/self-storage/rhode-island/cranston/',
				yearly_visitors: 88,
			},
			{
				name: 'Pawtucket',
				slug: '/self-storage/rhode-island/pawtucket/',
				yearly_visitors: 87,
			},
			{
				name: 'Newport',
				slug: '/self-storage/rhode-island/newport/',
				yearly_visitors: 84,
			},
			{
				name: 'Coventry',
				slug: '/self-storage/rhode-island/coventry/',
				yearly_visitors: 66,
			},
			{
				name: 'North Providence',
				slug: '/self-storage/rhode-island/north-providence/',
				yearly_visitors: 66,
			},
		],
	},
	{
		state: 'South Carolina',
		abbreviation: 'SC',
		cities: [
			{
				name: 'Columbia',
				slug: '/self-storage/south-carolina/columbia/',
				yearly_visitors: 1071,
			},
			{
				name: 'Charleston',
				slug: '/self-storage/south-carolina/charleston/',
				yearly_visitors: 833,
			},
			{
				name: 'Sumter',
				slug: '/self-storage/south-carolina/sumter/',
				yearly_visitors: 762,
			},
			{
				name: 'Mount Pleasant',
				slug: '/self-storage/south-carolina/mount-pleasant/',
				yearly_visitors: 660,
			},
			{
				name: 'Greenville',
				slug: '/self-storage/south-carolina/greenville/',
				yearly_visitors: 609,
			},
			{
				name: 'Clemson',
				slug: '/self-storage/south-carolina/clemson/',
				yearly_visitors: 569,
			},
			{
				name: 'Rock Hill',
				slug: '/self-storage/south-carolina/rock-hill/',
				yearly_visitors: 564,
			},
			{
				name: 'Conway',
				slug: '/self-storage/south-carolina/conway/',
				yearly_visitors: 484,
			},
			{
				name: 'Lexington',
				slug: '/self-storage/south-carolina/lexington/',
				yearly_visitors: 474,
			},
			{
				name: 'Aiken',
				slug: '/self-storage/south-carolina/aiken/',
				yearly_visitors: 323,
			},
		],
	},

	{
		state: 'South Dakota',
		abbreviation: 'SD',
		cities: [
			{
				name: 'Sioux Falls',
				slug: '/self-storage/south-dakota/sioux-falls/',
				yearly_visitors: 623,
			},
			{
				name: 'Rapid City',
				slug: '/self-storage/south-dakota/rapid-city/',
				yearly_visitors: '-',
			},
			{
				name: 'Brookings',
				slug: '/self-storage/south-dakota/brookings/',
				yearly_visitors: '-',
			},
			{
				name: 'Spearfish',
				slug: '/self-storage/south-dakota/spearfish/',
				yearly_visitors: '-',
			},
			{
				name: 'Aberdeen',
				slug: '/self-storage/south-dakota/aberdeen/',
				yearly_visitors: '-',
			},
			{
				name: 'Tea',
				slug: '/self-storage/south-dakota/tea/',
				yearly_visitors: '-',
			},
			{
				name: 'Watertown',
				slug: '/self-storage/south-dakota/watertown/',
				yearly_visitors: '-',
			},
			{
				name: 'Yankton',
				slug: '/self-storage/south-dakota/yankton/',
				yearly_visitors: '-',
			},
			{
				name: 'Vermillion',
				slug: '/self-storage/south-dakota/vermillion/',
				yearly_visitors: '-',
			},
			{
				name: 'Pierre',
				slug: '/self-storage/south-dakota/pierre/',
				yearly_visitors: '-',
			},
		],
	},
	{
		state: 'Tennessee',
		abbreviation: 'TN',
		cities: [
			{
				name: 'Knoxville',
				slug: '/self-storage/tennessee/knoxville/',
				yearly_visitors: 1104,
			},
			{
				name: 'Memphis',
				slug: '/self-storage/tennessee/memphis/',
				yearly_visitors: 1003,
			},
			{
				name: 'Chattanooga',
				slug: '/self-storage/tennessee/chattanooga/',
				yearly_visitors: 840,
			},
			{
				name: 'Clarksville',
				slug: '/self-storage/tennessee/clarksville/',
				yearly_visitors: 823,
			},
			{
				name: 'Murfreesboro',
				slug: '/self-storage/tennessee/murfreesboro/',
				yearly_visitors: 661,
			},
			{
				name: 'Nashville',
				slug: '/self-storage/tennessee/nashville/',
				yearly_visitors: 658,
			},
			{
				name: 'Johnson City',
				slug: '/self-storage/tennessee/johnson-city/',
				yearly_visitors: 353,
			},
			{
				name: 'Lebanon',
				slug: '/self-storage/tennessee/lebanon/',
				yearly_visitors: 203,
			},
			{
				name: 'Franklin',
				slug: '/self-storage/tennessee/franklin/',
				yearly_visitors: 191,
			},
			{
				name: 'Kingsport',
				slug: '/self-storage/tennessee/kingsport/',
				yearly_visitors: 180,
			},
		],
	},
	{
		state: 'Texas',
		abbreviation: 'TX',
		cities: [
			{
				name: 'Houston',
				slug: '/self-storage/texas/houston/',
				yearly_visitors: 2866,
			},
			{
				name: 'San Antonio',
				slug: '/self-storage/texas/san-antonio/',
				yearly_visitors: 1745,
			},
			{
				name: 'Fort Worth',
				slug: '/self-storage/texas/fort-worth/',
				yearly_visitors: 1388,
			},
			{
				name: 'Dallas',
				slug: '/self-storage/texas/dallas/',
				yearly_visitors: 1348,
			},
			{
				name: 'Laredo',
				slug: '/self-storage/texas/laredo/',
				yearly_visitors: 1295,
			},
			{
				name: 'College Station',
				slug: '/self-storage/texas/college-station/',
				yearly_visitors: 1266,
			},
			{
				name: 'Austin',
				slug: '/self-storage/texas/austin/',
				yearly_visitors: 1201,
			},
			{
				name: 'Abilene',
				slug: '/self-storage/texas/abilene/',
				yearly_visitors: 1010,
			},
			{
				name: 'Freeport',
				slug: '/self-storage/texas/freeport/',
				yearly_visitors: 975,
			},
			{
				name: 'Irving',
				slug: '/self-storage/texas/irving/',
				yearly_visitors: 970,
			},
		],
	},
	{
		state: 'Utah',
		abbreviation: 'UT',
		cities: [
			{
				name: 'Salt Lake City',
				slug: '/self-storage/utah/salt-lake-city/',
				yearly_visitors: 1424,
			},
			{
				name: 'Orem',
				slug: '/self-storage/utah/orem/',
				yearly_visitors: 747,
			},
			{
				name: 'West Jordan',
				slug: '/self-storage/utah/west-jordan/',
				yearly_visitors: 647,
			},
			{
				name: 'St George',
				slug: '/self-storage/utah/st-george/',
				yearly_visitors: 429,
			},
			{
				name: 'West Valley City',
				slug: '/self-storage/utah/west-valley-city/',
				yearly_visitors: 407,
			},
			{
				name: 'Ogden',
				slug: '/self-storage/utah/ogden/',
				yearly_visitors: 318,
			},
			{
				name: 'Provo',
				slug: '/self-storage/utah/provo/',
				yearly_visitors: 312,
			},
			{
				name: 'Bountiful',
				slug: '/self-storage/utah/bountiful/',
				yearly_visitors: 173,
			},
			{
				name: 'Murray',
				slug: '/self-storage/utah/murray/',
				yearly_visitors: 111,
			},
			{
				name: 'Layton',
				slug: '/self-storage/utah/layton/',
				yearly_visitors: 106,
			},
		],
	},
	{
		state: 'Vermont',
		abbreviation: 'VT',
		cities: [
			{
				name: 'Rutland',
				slug: '/self-storage/vermont/rutland/',
				yearly_visitors: 144,
			},
			{
				name: 'Brattleboro',
				slug: '/self-storage/vermont/brattleboro/',
				yearly_visitors: 95,
			},
			{
				name: 'Bennington',
				slug: '/self-storage/vermont/bennington/',
				yearly_visitors: 35,
			},
			{
				name: 'Barre',
				slug: '/self-storage/vermont/barre/',
				yearly_visitors: 0,
			},
			{
				name: 'Middlebury',
				slug: '/self-storage/vermont/middlebury/',
				yearly_visitors: '-',
			},
			{
				name: 'Burlington',
				slug: '/self-storage/vermont/burlington/',
				yearly_visitors: '-',
			},
			{
				name: 'Williston',
				slug: '/self-storage/vermont/williston/',
				yearly_visitors: '-',
			},
			{
				name: 'Barre',
				slug: '/self-storage/vermont/barre/',
				yearly_visitors: '-',
			},
			{
				name: 'St Johnsbury',
				slug: '/self-storage/vermont/st-johnsbury/',
				yearly_visitors: '-',
			},
			{
				name: 'Lyndonville',
				slug: '/self-storage/vermont/yyndonville/',
				yearly_visitors: '-',
			},
		],
	},
	{
		state: 'Virginia',
		abbreviation: 'VA',
		cities: [
			{
				name: 'Charlottesville',
				slug: '/self-storage/virginia/charlottesville/',
				yearly_visitors: 1312,
			},
			{
				name: 'Norfolk',
				slug: '/self-storage/virginia/norfolk/',
				yearly_visitors: 1176,
			},
			{
				name: 'Richmond',
				slug: '/self-storage/virginia/richmond/',
				yearly_visitors: 1143,
			},
			{
				name: 'Virginia Beach',
				slug: '/self-storage/virginia/virginia-beach/',
				yearly_visitors: 862,
			},
			{
				name: 'Roanoke',
				slug: '/self-storage/virginia/roanoke/',
				yearly_visitors: 620,
			},
			{
				name: 'Lynchburg',
				slug: '/self-storage/virginia/lynchburg/',
				yearly_visitors: 609,
			},
			{
				name: 'Alexandria',
				slug: '/self-storage/virginia/alexandria/',
				yearly_visitors: 551,
			},
			{
				name: 'Chesapeake',
				slug: '/self-storage/virginia/chesapeake/',
				yearly_visitors: 509,
			},
			{
				name: 'Suffolk',
				slug: '/self-storage/virginia/suffolk/',
				yearly_visitors: 449,
			},
			{
				name: 'Blacksburg',
				slug: '/self-storage/virginia/blacksburg/',
				yearly_visitors: 417,
			},
		],
	},
	{
		state: 'Washington',
		abbreviation: 'WA',
		cities: [
			{
				name: 'Seattle',
				slug: '/self-storage/washington/seattle/',
				yearly_visitors: 1435,
			},
			{
				name: 'Vancouver',
				slug: '/self-storage/washington/vancouver/',
				yearly_visitors: 804,
			},
			{
				name: 'Kent',
				slug: '/self-storage/washington/kent/',
				yearly_visitors: 641,
			},
			{
				name: 'Redmond',
				slug: '/self-storage/washington/redmond/',
				yearly_visitors: 610,
			},
			{
				name: 'Spokane',
				slug: '/self-storage/washington/spokane/',
				yearly_visitors: 562,
			},
			{
				name: 'Everett',
				slug: '/self-storage/washington/everett/',
				yearly_visitors: 497,
			},
			{
				name: 'Spokane Valley',
				slug: '/self-storage/washington/spokane-valley/',
				yearly_visitors: 487,
			},
			{
				name: 'Tacoma',
				slug: '/self-storage/washington/tacoma/',
				yearly_visitors: 391,
			},
			{
				name: 'Kennewick',
				slug: '/self-storage/washington/kennewick/',
				yearly_visitors: 351,
			},
			{
				name: 'Bellingham',
				slug: '/self-storage/washington/bellingham/',
				yearly_visitors: 314,
			},
		],
	},
	{
		state: 'West Virginia',
		abbreviation: 'WV',
		cities: [
			{
				name: 'Martinsburg',
				slug: '/self-storage/west-virginia/martinsburg/',
				yearly_visitors: 565,
			},
			{
				name: 'Morgantown',
				slug: '/self-storage/west-virginia/morgantown/',
				yearly_visitors: 413,
			},
			{
				name: 'Charleston',
				slug: '/self-storage/west-virginia/charleston/',
				yearly_visitors: 384,
			},
			{
				name: 'Huntington',
				slug: '/self-storage/west-virginia/huntington/',
				yearly_visitors: 316,
			},
			{
				name: 'Fairmont',
				slug: '/self-storage/west-virginia/fairmont/',
				yearly_visitors: 186,
			},
			{
				name: 'Wheeling',
				slug: '/self-storage/west-virginia/wheeling/',
				yearly_visitors: 76,
			},
			{
				name: 'Charles Town',
				slug: '/self-storage/west-virginia/charles-town/',
				yearly_visitors: 66,
			},
			{
				name: 'Clarksburg',
				slug: '/self-storage/west-virginia/clarksburg/',
				yearly_visitors: 47,
			},
			{
				name: 'Inwood',
				slug: '/self-storage/west-virginia/inwood/',
				yearly_visitors: 44,
			},
			{
				name: 'Weirton',
				slug: '/self-storage/west-virginia/weirton/',
				yearly_visitors: 43,
			},
		],
	},
	{
		state: 'Wisconsin',
		abbreviation: 'WI',
		cities: [
			{
				name: 'Milwaukee',
				slug: '/self-storage/wisconsin/milwaukee/',
				yearly_visitors: 1266,
			},
			{
				name: 'Madison',
				slug: '/self-storage/wisconsin/madison/',
				yearly_visitors: 664,
			},
			{
				name: 'Eau Claire',
				slug: '/self-storage/wisconsin/eau-claire/',
				yearly_visitors: 594,
			},
			{
				name: 'Racine',
				slug: '/self-storage/wisconsin/racine/',
				yearly_visitors: 339,
			},
			{
				name: 'Appleton',
				slug: '/self-storage/wisconsin/appleton/',
				yearly_visitors: 321,
			},
			{
				name: 'Green Bay',
				slug: '/self-storage/wisconsin/green-bay/',
				yearly_visitors: 276,
			},
			{
				name: 'Janesville',
				slug: '/self-storage/wisconsin/janesville/',
				yearly_visitors: 258,
			},
			{
				name: 'Sheboygan',
				slug: '/self-storage/wisconsin/sheboygan/',
				yearly_visitors: 242,
			},
			{
				name: 'Wausau',
				slug: '/self-storage/wisconsin/wausau/',
				yearly_visitors: 234,
			},
			{
				name: 'Stevens Point',
				slug: '/self-storage/wisconsin/stevens-point/',
				yearly_visitors: 210,
			},
		],
	},
	{
		state: 'Wyoming',
		abbreviation: 'WY',
		cities: [
			{
				name: 'Cheyenne',
				slug: '/self-storage/wyoming/cheyenne/',
				yearly_visitors: 878,
			},
			{
				name: 'Casper',
				slug: '/self-storage/wyoming/casper/',
				yearly_visitors: 651,
			},
			{
				name: 'Laramie',
				slug: '/self-storage/wyoming/laramie/',
				yearly_visitors: 47,
			},
			{
				name: 'Sheridan',
				slug: '/self-storage/wyoming/sheridan/',
				yearly_visitors: '-',
			},
			{
				name: 'Jackson',
				slug: '/self-storage/wyoming/jackson/',
				yearly_visitors: '-',
			},
			{
				name: 'Cody',
				slug: '/self-storage/wyoming/cody/',
				yearly_visitors: '-',
			},
			{
				name: 'Green River',
				slug: '/self-storage/wyoming/green-river/',
				yearly_visitors: '-',
			},
			{
				name: 'Rock Springs',
				slug: '/self-storage/wyoming/rock-springs/',
				yearly_visitors: '-',
			},
			{
				name: 'Cody',
				slug: '/self-storage/wyoming/cody/',
				yearly_visitors: '-',
			},
			{
				name: 'Evanston',
				slug: '/self-storage/wyoming/evanston/',
				yearly_visitors: '-',
			},
		],
	},
];
